/* ══════════════════════════════════════════════════════════════
   <product-page> — sections/product--split.liquid and its snippets
   (size-chart-modal, pdp-extras, pdp-butterfly, pdp-reviews).

   Variant picker, details / reviews / shipping panels, gallery sync,
   size chart, butterfly, video row and both reviews carousels.
   Loaded deferred, only on product pages. The two scripts that MOVE
   elements (pdp-page-css, pdp-extras placement) stay inline so nothing
   shifts after first paint.
   ══════════════════════════════════════════════════════════════ */
(function () {
  if (customElements.get('product-page')) return;

  var desktopMQ = window.matchMedia('(min-width: 1200px)');

  /* ── Main product section ─────────────────────────────────── */
  function initProduct(host, signal) {
    var root = host.querySelector('[data-pdp]');
    if (!root) return;

    var idField = root.querySelector('[data-pdp-variant-id]');
    var atc = root.querySelector('[data-pdp-atc]');
    var atcText = root.querySelector('[data-pdp-atc-text]');
    var priceEl = root.querySelector('[data-pdp-price]');
    var ADD = host.dataset.add || 'Add to cart';
    var SOLD = host.dataset.sold || 'Sold out';
    var MORE = host.dataset.more || 'Details';
    var LESS = host.dataset.less || 'Close';
    var UNAVAILABLE = 'Unavailable';

    var variants = [];
    try {
      var raw = root.querySelector('[data-pdp-variants]');
      if (raw) variants = JSON.parse(raw.textContent);
    } catch (err) { variants = []; }

    var optionGroups = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-option]'));

    function selectedValues() {
      return optionGroups.map(function (group) {
        var on = group.querySelector('[data-pdp-value].is-selected');
        return on ? on.getAttribute('data-value') : null;
      });
    }

    function findVariant(values) {
      return variants.find(function (v) {
        return values.every(function (val, i) { return v.options[i] === val; });
      });
    }

    function markAvailability(values) {
      optionGroups.forEach(function (group, gi) {
        group.querySelectorAll('[data-pdp-value]').forEach(function (btn) {
          var test = values.slice();
          test[gi] = btn.getAttribute('data-value');
          var possible = variants.some(function (v) {
            return test.every(function (val, i) {
              return val === null ? true : v.options[i] === val;
            }) && v.available;
          });
          btn.classList.toggle('is-soldout', !possible);
        });
      });
    }

    function update() {
      var values = selectedValues();
      markAvailability(values);
      var match = findVariant(values);

      if (!match) {
        if (atc) atc.disabled = true;
        if (atcText) atcText.textContent = UNAVAILABLE;
        return;
      }

      if (idField) idField.value = match.id;
      if (atc) atc.disabled = !match.available;
      if (atcText) atcText.textContent = match.available ? ADD : SOLD;
      var atcPrice = root.querySelector('[data-pdp-atc-price]');
      if (atcPrice) { atcPrice.hidden = !match.available; atcPrice.textContent = ' \u00b7 ' + match.price; }
      var stock = root.querySelector('[data-pdp-stock]');
      if (stock) {
        var limit = parseInt(stock.dataset.pdpStockThreshold, 10) || 5;
        var low = match.managed && match.available && match.qty > 0 && match.qty <= limit;
        stock.hidden = !low;
        if (low) {
          stock.querySelector('[data-pdp-stock-text]').textContent = match.qty === 1 ? 'Only 1 left' : 'Only ' + match.qty + ' left';
          stock.querySelector('[data-pdp-stock-fill]').style.width = Math.max(8, Math.round(match.qty / (limit * 2) * 100)) + '%';
        }
      }

      if (priceEl) {
        priceEl.innerHTML = match.compare
          ? '<span class="pdp__price-sale money">' + match.price + '</span><span class="pdp__price-compare money">' + match.compare + '</span>'
          : '<span class="money">' + match.price + '</span>';
      }

      try {
        var url = new URL(window.location);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url);
      } catch (err) {}
    }

    /* Mobile: the right column is a fixed dock, so pad the page by its height. */
    var dock = root.querySelector('.pdp__col--right');
    function syncDock() {
      if (!dock) return;
      if (desktopMQ.matches) {
        document.body.style.paddingBottom = '';
        return;
      }
      document.body.style.paddingBottom = (dock.offsetHeight + 8) + 'px';
    }

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-pdp-value]');
      if (!btn) return;
      var gi = btn.getAttribute('data-option-index');
      var group = root.querySelector('[data-pdp-option="' + gi + '"]');
      if (!group) return;
      group.querySelectorAll('[data-pdp-value]').forEach(function (b) {
        b.classList.toggle('is-selected', b === btn);
      });
      update();
      syncDock();
    }, { signal: signal });

    var more = root.querySelector('[data-pdp-more]');
    var morePanel = root.querySelector('[data-pdp-more-panel]');
    if (more && morePanel) {
      more.addEventListener('click', function () {
        var open = more.getAttribute('aria-expanded') === 'true';
        more.setAttribute('aria-expanded', open ? 'false' : 'true');
        morePanel.classList.toggle('is-open', !open);
        var label = more.querySelector('[data-pdp-more-text]');
        if (label) label.textContent = open ? MORE : LESS;
      }, { signal: signal });
    }

    var revBtn = root.querySelector('[data-pdp-reviews]');
    var revPanel = root.querySelector('[data-pdp-reviews-panel]');
    if (revBtn && revPanel) {
      revBtn.addEventListener('click', function () {
        var open = revBtn.getAttribute('aria-expanded') === 'true';
        revBtn.setAttribute('aria-expanded', open ? 'false' : 'true');
        revPanel.classList.toggle('is-open', !open);
      }, { signal: signal });
    }

    /* Gallery: scroll-driven on desktop, swipe on mobile. */
    var gallery = root.querySelector('[data-pdp-gallery]');
    var media = root.querySelector('[data-pdp-media]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('.pdp__slide'));
    var ticks = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-tick]'));

    function setActive(i) {
      slides.forEach(function (sl, n) { sl.classList.toggle('is-active', n === i); });
      ticks.forEach(function (tk, n) { tk.classList.toggle('is-active', n === i); });
    }

    var ticking = false;
    function onScroll() {
      if (ticking || !desktopMQ.matches || !gallery) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var rect = gallery.getBoundingClientRect();
        var travel = rect.height - window.innerHeight;
        var progress = travel > 0 ? (-rect.top) / travel : 0;
        progress = Math.min(Math.max(progress, 0), 0.9999);
        setActive(Math.floor(progress * slides.length));
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true, signal: signal });

    if (media) {
      media.addEventListener('scroll', function () {
        if (desktopMQ.matches) return;
        setActive(Math.round(media.scrollLeft / media.clientWidth));
      }, { passive: true, signal: signal });
    }

    desktopMQ.addEventListener('change', function () {
      setActive(0);
      if (media && !desktopMQ.matches) media.scrollLeft = 0;
      onScroll();
      syncDock();
    }, { signal: signal });

    var ship = root.querySelector('[data-pdp-ship]');
    if (ship) {
      var shipOpen = function () {
        ship.hidden = false;
        ship.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      };
      var shipClose = function () {
        ship.hidden = true;
        ship.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      };
      root.addEventListener('click', function (e) {
        if (e.target.closest('[data-pdp-ship-open]')) { e.preventDefault(); shipOpen(); return; }
        if (e.target.closest('[data-pdp-ship-close]')) { shipClose(); }
      }, { signal: signal });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !ship.hidden) shipClose();
      }, { signal: signal });
    }

    update();
    syncDock();
    onScroll();

    /* Resize work is batched to one measurement per frame. */
    var queued = false;
    window.addEventListener('resize', function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; syncDock(); });
    }, { passive: true, signal: signal });

    if (document.readyState === 'complete') { syncDock(); onScroll(); }
    else window.addEventListener('load', function () { syncDock(); onScroll(); }, { once: true, signal: signal });
  }

  /* ── Size chart modal (snippets/size-chart-modal) ─────────── */
  function initSizeChart(signal) {
    var modal = document.getElementById('sc-modal');
    if (!modal) return;
    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var closeBtn = modal.querySelector('.sc-modal__close');
      if (closeBtn) closeBtn.focus();
    }
    function close() {
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-sc-open]')) { e.preventDefault(); open(); return; }
      if (e.target.closest('[data-sc-close]')) { close(); }
    }, { signal: signal });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    }, { signal: signal });

    var unitsWrap = modal.querySelector('.sc-units');
    var base = unitsWrap ? (unitsWrap.getAttribute('data-base-unit') || 'cm') : 'cm';
    var unit = 'cm';

    function convert(value) {
      var v = parseFloat(value);
      if (isNaN(v)) return null;
      if (base === 'cm' && unit === 'in') v = v / 2.54;
      if (base === 'in' && unit === 'cm') v = v * 2.54;
      return Math.round(v * 10) / 10;
    }

    function render() {
      var active = modal.querySelector('[data-sc-size].is-active');
      if (!active) return;
      var suffix = unit === 'cm' ? ' cm' : '"';
      ['a', 'b', 'c'].forEach(function (dim) {
        var out = convert(active.getAttribute('data-' + dim));
        var text = out === null ? '–' : out + suffix;
        var onDrawing = modal.querySelector('[data-sc-dim="' + dim + '"]');
        if (onDrawing) onDrawing.textContent = text;
        var inKey = modal.querySelector('[data-sc-dim-out="' + dim + '"]');
        if (inKey) inKey.textContent = text;
      });
    }

    modal.addEventListener('click', function (e) {
      var sizeBtn = e.target.closest('[data-sc-size]');
      if (sizeBtn) {
        modal.querySelectorAll('[data-sc-size]').forEach(function (b) {
          b.classList.toggle('is-active', b === sizeBtn);
        });
        render();
        return;
      }
      var unitBtn = e.target.closest('[data-sc-unit]');
      if (unitBtn) {
        unit = unitBtn.getAttribute('data-sc-unit');
        modal.querySelectorAll('[data-sc-unit]').forEach(function (b) {
          b.classList.toggle('is-active', b === unitBtn);
        });
        render();
      }
    }, { signal: signal });

    render();
  }

  /* ── Butterfly on the size guide button (snippets/pdp-butterfly) ──
     Flies in, perches on the button's rim, leaves, returns every 35-70s.
     If the button can't be measured it retries briefly, then falls back
     to the normal 35-70s rhythm instead of re-checking twice a second. */
  function initButterfly(signal) {
    var bfly = document.querySelector('[data-bfly]');
    if (!bfly || bfly.dataset.bflyInit) return;
    bfly.dataset.bflyInit = '1';

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) { bfly.remove(); return; }
    if (typeof bfly.animate !== 'function') { bfly.remove(); return; }

    document.body.appendChild(bfly);

    var FIRST_MIN = 1000, FIRST_MAX = 2000;
    var AGAIN_MIN = 35000, AGAIN_MAX = 70000;
    var PERCH_MIN = 5000, PERCH_MAX = 9000;
    var IN_MS = 2400, OUT_MS = 1700;
    var RETRIES = 10;

    function rand(a, b) { return a + Math.random() * (b - a); }

    function target() {
      var buttons = document.querySelectorAll('[data-sc-open]');
      for (var i = 0; i < buttons.length; i++) {
        var r = buttons[i].getBoundingClientRect();
        if (r.width && r.height) return buttons[i];
      }
      return null;
    }

    var busy = false;
    var misses = 0;
    var timer;

    function schedule(min, max) {
      clearTimeout(timer);
      timer = setTimeout(visit, rand(min, max));
    }

    function visit() {
      if (busy || document.hidden) return schedule(AGAIN_MIN, AGAIN_MAX);

      var btn = target();
      if (!btn) {
        misses += 1;
        return misses < RETRIES ? schedule(400, 900) : schedule(AGAIN_MIN, AGAIN_MAX);
      }
      misses = 0;
      busy = true;

      var r = btn.getBoundingClientRect();
      var size = bfly.offsetWidth || 18;
      var lx = r.left + window.scrollX + (r.width / 2) - (size / 2);
      var ly = r.top + window.scrollY - size + (size * 0.22);

      var cx = r.left + r.width / 2;
      var fromLeft = cx > window.innerWidth / 2;
      var sx = fromLeft ? -60 : window.innerWidth + 60;
      var sy = ly - rand(120, 220);

      bfly.style.transform = 'translate(' + sx + 'px,' + sy + 'px)';
      bfly.classList.add('is-out', 'is-flying');

      var midX = (sx + lx) / 2 + rand(-70, 70);
      var midY = Math.min(sy, ly) - rand(40, 90);
      var nearX = lx + (fromLeft ? -26 : 26);
      var nearY = ly - 28;

      var flyIn = bfly.animate([
        { transform: 'translate(' + sx + 'px,' + sy + 'px) rotate(' + (fromLeft ? 12 : -12) + 'deg)' },
        { transform: 'translate(' + midX + 'px,' + midY + 'px) rotate(' + (fromLeft ? 6 : -6) + 'deg)', offset: 0.55 },
        { transform: 'translate(' + nearX + 'px,' + nearY + 'px) rotate(0deg)', offset: 0.85 },
        { transform: 'translate(' + lx + 'px,' + ly + 'px) rotate(0deg)' }
      ], { duration: IN_MS, easing: 'cubic-bezier(0.32, 0.72, 0, 1)', fill: 'forwards' });

      flyIn.onfinish = function () {
        bfly.classList.remove('is-flying');
        bfly.classList.add('is-perched');

        setTimeout(function () {
          bfly.classList.remove('is-perched');
          bfly.classList.add('is-flying');

          var ex = fromLeft ? window.innerWidth + 80 : -80;
          var ey = ly - rand(140, 240);

          var flyOut = bfly.animate([
            { transform: 'translate(' + lx + 'px,' + ly + 'px) rotate(0deg)', opacity: 1 },
            { transform: 'translate(' + ((lx + ex) / 2) + 'px,' + (ly - 70) + 'px) rotate(' + (fromLeft ? -8 : 8) + 'deg)', opacity: 1, offset: 0.5 },
            { transform: 'translate(' + ex + 'px,' + ey + 'px) rotate(' + (fromLeft ? -14 : 14) + 'deg)', opacity: 0 }
          ], { duration: OUT_MS, easing: 'cubic-bezier(0.4, 0, 0.7, 0.2)', fill: 'forwards' });

          flyOut.onfinish = function () {
            bfly.classList.remove('is-out', 'is-flying');
            busy = false;
            schedule(AGAIN_MIN, AGAIN_MAX);
          };
        }, rand(PERCH_MIN, PERCH_MAX));
      };
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) clearTimeout(timer);
      else if (!busy) schedule(AGAIN_MIN, AGAIN_MAX);
    }, { signal: signal });
    signal.addEventListener('abort', function () { clearTimeout(timer); });

    schedule(FIRST_MIN, FIRST_MAX);
  }

  /* ── Video row + reviews carousel (snippets/pdp-extras) ──
     Placement of these blocks happens inline in the snippet. Videos only
     resume, and the carousel only restarts, if they are on screen when the
     tab becomes visible again. */
  function initExtras(signal) {
    if (!document.querySelector('.pdp__col--left .pdp__col-inner')) return;

    var vids = Array.prototype.slice.call(document.querySelectorAll('[data-pdx-vid]'));

    function load(v) {
      if (v.dataset.loaded) return;
      v.preload = 'metadata';
      v.src = v.getAttribute('data-src');
      v.dataset.loaded = '1';
    }

    function hushEverythingElse(except) {
      var media = document.querySelectorAll('audio, video');
      for (var i = 0; i < media.length; i++) {
        var el = media[i];
        if (el === except || el.muted) continue;
        try { el.pause(); } catch (e) {}
      }
      document.dispatchEvent(new CustomEvent('pcmkr:pause-audio'));
    }

    if (vids.length && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var v = entry.target;
          v._pdxInView = entry.isIntersecting;
          if (entry.isIntersecting) {
            load(v);
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } else if (v.dataset.loaded) {
            v.pause();
          }
        });
      }, { rootMargin: '300px 0px' });
      vids.forEach(function (v) { io.observe(v); });
      signal.addEventListener('abort', function () { io.disconnect(); });
    } else {
      vids.forEach(function (v) { v._pdxInView = true; load(v); v.play().catch(function () {}); });
    }

    var overlay = document.createElement('div');
    overlay.className = 'pdx__fs';
    overlay.hidden = true;
    var overlayClose = document.createElement('button');
    overlayClose.type = 'button';
    overlayClose.className = 'pdx__fs-close';
    overlayClose.setAttribute('aria-label', 'Close video');
    overlayClose.textContent = '✕';
    overlay.appendChild(overlayClose);
    document.body.appendChild(overlay);
    signal.addEventListener('abort', function () { overlay.remove(); });

    var overlayVideo = null;
    function closeOverlay() {
      if (overlayVideo) {
        overlayVideo.pause();
        if (overlayVideo.parentNode) overlay.removeChild(overlayVideo);
        overlayVideo = null;
      }
      overlay.hidden = true;
      document.body.style.overflow = '';
    }
    overlayClose.addEventListener('click', closeOverlay);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closeOverlay(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !overlay.hidden) closeOverlay();
    }, { signal: signal });

    function openOverlay(v) {
      var clone = document.createElement('video');
      clone.src = v.getAttribute('data-src');
      clone.controls = true;
      clone.autoplay = true;
      clone.playsInline = true;
      clone.loop = true;
      clone.preload = 'auto';
      clone.muted = false;
      overlay.appendChild(clone);
      overlayVideo = clone;
      overlay.hidden = false;
      document.body.style.overflow = 'hidden';
      if (v.currentTime) {
        clone.addEventListener('loadedmetadata', function () {
          try { clone.currentTime = v.currentTime; } catch (e) {}
        });
      }
      hushEverythingElse(clone);
      clone.play().catch(function () {});
    }

    /* Metadata is preloaded as the row nears the viewport, so fullscreen can
       be requested synchronously inside the tap (iOS needs that). */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-pdx-play]');
      if (!btn) return;
      var v = btn.querySelector('[data-pdx-vid]');
      if (!v) return;
      load(v);
      var desktopPointer = window.matchMedia('(min-width: 1200px) and (hover: hover)').matches;
      if (!desktopPointer && v.readyState >= 1) {
        var entered = false;
        try {
          if (v.requestFullscreen) { v.requestFullscreen(); entered = true; }
          else if (v.webkitEnterFullscreen) { v.webkitEnterFullscreen(); entered = true; }
          else if (v.webkitRequestFullscreen) { v.webkitRequestFullscreen(); entered = true; }
        } catch (err) { entered = false; }
        if (entered) {
          hushEverythingElse(v);
          v.muted = false;
          v.volume = 1;
          v.controls = true;
          v.play().catch(function () {});
          return;
        }
      }
      openOverlay(v);
    }, { signal: signal });

    ['fullscreenchange', 'webkitfullscreenchange', 'webkitendfullscreen'].forEach(function (ev) {
      document.addEventListener(ev, function () {
        if (document.fullscreenElement || document.webkitFullscreenElement) return;
        vids.forEach(function (v) {
          v.muted = true;
          v.controls = false;
          v.play().catch(function () {});
        });
      }, { signal: signal });
    });

    document.addEventListener('visibilitychange', function () {
      vids.forEach(function (v) {
        if (document.hidden) v.pause();
        else if (v.dataset.loaded && overlay.hidden && v._pdxInView) v.play().catch(function () {});
      });
    }, { signal: signal });

    /* Reviews carousel */
    var track = document.querySelector('[data-pdx-rev-track]');
    if (!track) return;
    var slides = track.querySelectorAll('[data-pdx-rev]');
    if (slides.length < 2) return;

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var HOLD = 5200;
    var GLIDE = 1100;
    var index = 0;
    var timer = null;
    var paused = false;
    var animating = false;
    var inView = !('IntersectionObserver' in window);

    function ease(t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }

    function glideTo(target) {
      if (reduced) { track.scrollLeft = target; return; }
      var startPos = track.scrollLeft;
      var delta = target - startPos;
      if (Math.abs(delta) < 1) return;
      var t0 = null;
      animating = true;
      function step(now) {
        if (t0 === null) t0 = now;
        var p = Math.min((now - t0) / GLIDE, 1);
        track.scrollLeft = startPos + delta * ease(p);
        if (p < 1) window.requestAnimationFrame(step); else animating = false;
      }
      window.requestAnimationFrame(step);
    }

    function go(i) {
      index = (i + slides.length) % slides.length;
      glideTo(index * track.clientWidth);
    }
    function stop() { if (timer) clearInterval(timer); timer = null; }
    function start() {
      stop();
      if (reduced || !inView || document.hidden) return;
      timer = setInterval(function () { if (!paused) go(index + 1); }, HOLD);
    }
    signal.addEventListener('abort', stop);

    ['mouseenter', 'pointerdown', 'touchstart', 'focusin'].forEach(function (ev) {
      track.addEventListener(ev, function () { paused = true; }, { passive: true, signal: signal });
    });
    ['mouseleave', 'pointerup', 'touchend', 'focusout'].forEach(function (ev) {
      track.addEventListener(ev, function () { setTimeout(function () { paused = false; }, 800); }, { passive: true, signal: signal });
    });

    var scrollWait;
    track.addEventListener('scroll', function () {
      if (animating) return;
      clearTimeout(scrollWait);
      scrollWait = setTimeout(function () { index = Math.round(track.scrollLeft / track.clientWidth); }, 140);
    }, { passive: true, signal: signal });

    if ('IntersectionObserver' in window) {
      var tio = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          inView = entry.isIntersecting;
          if (inView) start(); else stop();
        });
      }, { threshold: 0.2 });
      tio.observe(track);
      signal.addEventListener('abort', function () { tio.disconnect(); });
    } else {
      start();
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    }, { signal: signal });

    window.addEventListener('resize', function () { track.scrollLeft = index * track.clientWidth; }, { passive: true, signal: signal });
  }

  /* ── Reviews panel carousel (snippets/pdp-reviews) ──
     Auto-advances only while the reviews panel is open and the tab is
     visible; it used to tick every 5.2s behind a closed panel. */
  function initReviews(signal) {
    var root = document.querySelector('[data-rev]');
    if (!root) return;
    var viewport = root.querySelector('[data-rev-viewport]');
    var track = root.querySelector('[data-rev-track]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-rev-dot]'));
    var count = track.children.length;
    if (count < 2) return;

    var i = 0, timer = null, w = 0;
    var AUTO = 5200;
    var panel = root.closest('[data-pdp-reviews-panel]');

    function isShowing() { return !document.hidden && (!panel || panel.classList.contains('is-open')); }
    function measure() { w = viewport.clientWidth; }
    function render(animate) {
      track.style.transition = animate === false ? 'none' : '';
      track.style.transform = 'translate3d(' + (-i * w) + 'px,0,0)';
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
    }
    function go(n) { i = (n + count) % count; render(); }
    function stop() { if (timer) clearInterval(timer); timer = null; }
    function start() {
      stop();
      if (!isShowing()) return;
      timer = setInterval(function () { go(i + 1); }, AUTO);
    }
    signal.addEventListener('abort', stop);

    measure(); render(false); start();

    var queued = false;
    window.addEventListener('resize', function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; measure(); render(false); });
    }, { passive: true, signal: signal });

    dots.forEach(function (d) {
      d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-rev-dot'), 10)); start(); }, { signal: signal });
    });

    root.addEventListener('mouseenter', stop, { signal: signal });
    root.addEventListener('mouseleave', start, { signal: signal });

    var down = false, startX = 0, dx = 0;
    function pointerUp() {
      if (!down) return;
      down = false;
      track.classList.remove('is-dragging');
      viewport.classList.remove('is-dragging');
      if (Math.abs(dx) > w * 0.18) go(dx < 0 ? i + 1 : i - 1);
      else render();
      start();
    }
    viewport.addEventListener('pointerdown', function (e) {
      down = true; dx = 0; startX = e.clientX;
      stop();
      track.classList.add('is-dragging');
      viewport.classList.add('is-dragging');
      viewport.setPointerCapture(e.pointerId);
    }, { signal: signal });
    viewport.addEventListener('pointermove', function (e) {
      if (!down) return;
      dx = e.clientX - startX;
      track.style.transform = 'translate3d(' + (-i * w + dx) + 'px,0,0)';
    }, { signal: signal });
    viewport.addEventListener('pointerup', pointerUp, { signal: signal });
    viewport.addEventListener('pointercancel', pointerUp, { signal: signal });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    }, { signal: signal });

    /* The panel opens from zero height, so width is 0 until then — remeasure,
       and start/stop the auto-advance with the panel. */
    if (panel) {
      var mo = new MutationObserver(function () {
        start();
        setTimeout(function () { measure(); render(false); }, 340);
      });
      mo.observe(panel, { attributes: true, attributeFilter: ['class'] });
      signal.addEventListener('abort', function () { mo.disconnect(); });
    }
  }

  class ProductPage extends HTMLElement {
    connectedCallback() {
      this.ac = new AbortController();
      var signal = this.ac.signal;
      initProduct(this, signal);
      initSizeChart(signal);
      initButterfly(signal);
      initExtras(signal);
      initReviews(signal);
    }
    disconnectedCallback() {
      this.ac.abort();
    }
  }

  customElements.define('product-page', ProductPage);
})();
